var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m27.52 18.91 1.57 1.57-15.477 15.478h-1.571v-1.571l15.477-15.478m6.15-10.284c-.427 0-.871.17-1.196.495l-3.126 3.127 6.406 6.406 3.127-3.126a1.701 1.701 0 0 0 0-2.41L34.882 9.12a1.678 1.678 0 0 0-1.213-.495m-6.15 5.45L8.625 32.969v6.406h6.406l18.894-18.894z"
  }))));
};
export default SvgPencil;